
import request from '@/utils/request';
import { ENABLE_API_DBG } from '@/appConfig.js';

function list (params) {
  const newParams = {...params};
  if (newParams.max) {
    newParams.take = newParams.max;
    delete newParams.max;
  }
  if (newParams.offset) {
    newParams.skip = newParams.offset;
    delete newParams.offset;
  }
    
  const qsParams = new URLSearchParams();
  for (let [key, value] of Object.entries(newParams)) {
    qsParams.append(key, value);
  }
  //console.log(`api.dept-member.list: qsParams = ${qsParams.toString()}`);
  const url = `/dept-member?${qsParams.toString()}`;
  ENABLE_API_DBG && console.log(`api.deptMember.list: url = ${JSON.stringify(url)}`)
  return request({
    url,
    method: 'get',
    data: newParams
  })
}
function get (itemId) {
  return request({
    url: `/dept-member/${itemId}`,
    method: 'get'
  })
}
function getWithTags (itemId) {
  return request({
    url: `/dept-member/${itemId}?relation=tags`,
    method: 'get'
  })
}
function getWithGroups (itemId) {
  return request({
    url: `/dept-member/${itemId}?relation=groups`,
    method: 'get'
  })
}
function search (params) {
  return request({
    url: `/dept-member/search`,
    method: 'post',
    data: params
  })
}
function add (params) {
  ENABLE_API_DBG && console.log(`api.deptMember.add: params = ${JSON.stringify(params)}`)
  return request({
    url: `/dept-member`,
    method: 'post',
    data: params
  })
}
function update (params) {
  return request({
    url: `/dept-member/${params.id}`,
    method: 'patch',
    data: params
  })
}
function remove (itemId) {
  const url = `/dept-member/${itemId}`;
  ENABLE_API_DBG && console.log(`api.deptMember.remove: url = ${url}`)
  return request({
    url,
    method: 'delete'
  })
}
export default {
    list,
    search,
    add,
    update,
    remove,
    get,
    getWithTags,
    getWithGroups
}
